import React, { Fragment, useEffect, useState } from "react";
import { Button, Modal, Popover, Table, Tag, Tooltip } from "antd";
import { Badge, } from "antd";
import { EyeOutlined, DeleteOutlined, FileOutlined, FileTextOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../axios/axios";
import { toast } from "react-toastify";
import { clearLocalStorageExceptOne } from "../../common/Utilities";
import UploadedDocuments from "../../components/UploadedDocuments/UploadedDocuments";
import generateImage from '../../images/generate_invoice.png';
import paymentImage from '../../images/payment_details.png';
import invoiceImage from '../../images/invoice_details.png';

const LoanTabDatas = (props) => {
    const { data, type } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const pagePermission = location?.state;
    const [listDetails, setListDetails] = useState([]);
    const [columnType, setColumnType] = useState();
    const moment = require("moment");
    const [delModal, setDelModal] = useState(false);
    const [delId, setDelid] = useState(null);
    const [seconds, setSeconds] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const customLocale = {
        emptyText: type == "disbursement" ? "No Disbursement Made" : "No Data",
    };

    const AddLabelToFile = (arr, value) => {
        const files = (Array.isArray(arr) ? arr : arr ? [arr] : [])
            .map(file => {
                if (typeof file === "string") {
                    try {
                        return JSON.parse(file);
                    } catch (e) {
                        console.warn("Failed to parse file string:", file);
                        return { name: file };
                    }
                }
                return file;
            })
            .flat();
        return {
            label: value,
            files
        };
    };

    const columns = [
        {
            title: "Application ID",
            dataIndex: "id",
            fixed: window.innerWidth < 767 ? " " : "left",
            width: 100,
            sorter: false,
            render: (text, record) => {
                if (text) {
                    return {
                        children: (
                            <>
                                <span>OAP-{record.unique_id.toString().padStart(6, "0")}</span>
                                {record?.dealer_name && (
                                    <p className="font-[700]">{record?.dealer_name}</p>
                                )}
                            </>
                        ),
                    };
                }
            },
        },
        {
            title: "Loan Type",
            dataIndex: "loan_type",
            sorter: false,
            width: 100,
            render: (_, { loan_type }) => (
                <>
                    {loan_type != undefined &&
                        loan_type.map((tag) => {
                            return (
                                <Tag
                                    className="mb-2 text-center"
                                    style={{ width: "80px" }}
                                    color={"#DDEAFF"}
                                    key={tag}
                                >
                                    <span className="font-[600]" style={{ color: "#0560FB" }}>
                                        {tag.toUpperCase()}
                                    </span>
                                </Tag>
                            );
                        })}
                </>
            ),
        },
        {
            title: "Veh/Chassis No",
            dataIndex: "veh_chassis_no",
            sorter: false,
            width: 130,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            <span
                                onClick={() => {
                                    localStorage.setItem("applicationId", record.id);
                                    navigate("/case-detail", {
                                        state: { Id: record.id, pagePermission: pagePermission },
                                    });
                                }}
                                className="text-[#0560FB] text-[13px] font-[700] cursor-pointer"
                            >
                                {record.vehicle_reg_no}
                            </span>
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Make/Model",
            dataIndex: "veh_make_model",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Loan Amt",
            dataIndex: "loan_amt",
            sorter: false,
            width: 90,
            render: (text, record) => {
                const displayValue =
                    record.counter_loan_amt !== undefined &&
                        record.counter_loan_amt !== null &&
                        record.counter_loan_amt !== ""
                        ? record.counter_loan_amt
                        : text;

                if (!record.isCategoryRow) {
                    return {
                        children: (
                            <p>${parseInt(displayValue).toFixed(0)}</p>
                        ),
                    };
                } else {
                    return {
                        children: (
                            <div className="category-row-container h-[25px]">{displayValue}</div>
                        ),
                    };
                }
            },
        },
        {
            title: "Customer Selected",
            dataIndex: "customer_selected",
            sorter: false,
            width: 140,
            render: (text, record) => {
                if (!record.isCategoryRow) {
                    return (
                        <div className="flex justify-center items-center">
                            <img
                                src={
                                    record.customer_selected > 0
                                        ? "/images/selected.png"
                                        : "/images/rejected.png"
                                }
                                alt="Centered Image"
                                className="max-w-full max-h-full"
                            />
                        </div>
                    );
                }
            },
        },
        {
            title: "Application Status",
            dataIndex: "approved",
            sorter: false,
            width: 170,
            render: (text, record) => {
                if (!record.isCategoryRow) {
                    return (
                        <div className="text-start">
                            <Popover content={"Approved"}>
                                <Badge
                                    className="mr-2 badge"
                                    title=" "
                                    showZero={true}
                                    color="#00AE11"
                                    style={{ width: "30px" }}
                                    count={record.approved}
                                />
                            </Popover>
                            <Popover content={"Counter Offer"}>
                                <Badge
                                    className="mr-2"
                                    title=" "
                                    showZero
                                    color="#f48037"
                                    style={{ width: "30px" }}
                                    count={record.counter}
                                />
                            </Popover>
                            <Popover content={"Rejected"}>
                                <Badge
                                    className="mr-2"
                                    title=" "
                                    showZero
                                    color="#D30000"
                                    style={{ width: "30px" }}
                                    count={record.rejected}
                                />
                            </Popover>
                            <Popover content={"Pending"}>
                                <Badge
                                    className="mr-2"
                                    title=" "
                                    showZero
                                    color="#D4D4D4"
                                    style={{ width: "30px" }}
                                    count={record.pending}
                                />
                            </Popover>
                        </div>
                    );
                }
            },
        },
        {
            title: "Created at",
            dataIndex: "created_at",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div className="text-[#1B252F] text-[13px]">
                            {record.created_at}
                        </div>
                    </Fragment>
                );
            },
        },
        {
            title: "Case Exp",
            dataIndex: "expiry",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <div className="text-[#1B252F] text-[13px]">
                        {record.expiryDateTime}
                    </div>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            width: 90,
            render: (text, record) => {
                if (!record.isCategoryRow) {
                    return (
                        <div>
                            {pagePermission?.view_permission == 1 && (
                                <span
                                    onClick={() => {
                                        clearLocalStorageExceptOne("agentModuleToken");
                                        localStorage.setItem("applicationId", record.id);
                                        localStorage.removeItem("tabValue");
                                        navigate("/case-detail", {
                                            state: { Id: record.id, pagePermission: pagePermission },
                                        });
                                    }}
                                    className="mb-2 text-[#203B50] text-[14px] flex flex-wrap cursor-pointer border-none shadow-none"
                                >
                                    <EyeOutlined className="mt-1" />
                                    <span>&nbsp;View</span>
                                </span>
                            )}
                            {pagePermission?.delete_permission == 1 && (
                                <span
                                    className="mb-2 text-[#F80707] text-[14px] flex flex-wrap cursor-pointer border-none shadow-none"
                                    onClick={() => {
                                        if (Number(record.approved) == 0) {
                                            setDelModal(true);
                                            setDelid(record.id);
                                        } else {
                                            toast.warning(`You have approved ${record.approved} loan products. Please reject it and try again.`)
                                        }
                                    }}
                                >
                                    <DeleteOutlined className="mt-1" />
                                    <span>&nbsp;Delete</span>
                                </span>
                            )}
                        </div>
                    );
                }
            },
        },
    ];
    const disbursementcolumns = [
        {
            title: "Application ID",
            dataIndex: "id",
            fixed: window.innerWidth < 767 ? " " : "left",
            width: 100,
            sorter: false,
            render: (text, record) => {
                if (text) {
                    return {
                        children: (
                            <>
                                <div>OAP-{record.unique_id.toString().padStart(6, "0")}</div>
                                {record?.dealer_name && (
                                    <div className="font-[700]">{record?.dealer_name}</div>
                                )}
                                <div>{record?.product_name}</div>
                            </>
                        ),
                    };
                }
            },
        },
        {
            title: "Loan Type",
            dataIndex: "loan_type",
            sorter: false,
            width: 100,
            render: (_, { loan_type }) => (
                <>
                    {loan_type != undefined &&
                        loan_type.map((tag) => {
                            return (
                                <Tag
                                    className="mb-2 text-center"
                                    style={{ width: "80px" }}
                                    color={"#DDEAFF"}
                                    key={tag}
                                >
                                    <span className="font-[600]" style={{ color: "#0560FB" }}>
                                        {tag.toUpperCase()}
                                    </span>
                                </Tag>
                            );
                        })}
                </>
            ),
        },
        {
            title: "Veh/Chassis No",
            dataIndex: "veh_chassis_no",
            sorter: false,
            width: 130,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            <span
                                onClick={() => {
                                    localStorage.setItem("applicationId", record.id);
                                    navigate("/case-detail", {
                                        state: { Id: record.id, pagePermission: pagePermission },
                                    });
                                }}
                                className="text-[#0560FB] text-[13px] font-[700] cursor-pointer"
                            >
                                {record.vehicle_reg_no}
                            </span>
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Make/Model",
            dataIndex: "veh_make_model",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Loan Amt",
            dataIndex: "loan_amt",
            sorter: false,
            width: 90,
            render: (text, record) => {
                const displayValue =
                    record.counter_loan_amt !== undefined &&
                        record.counter_loan_amt !== null &&
                        record.counter_loan_amt !== ""
                        ? record.counter_loan_amt
                        : text;

                if (!record.isCategoryRow) {
                    return {
                        children: (
                            <p>${parseInt(displayValue).toFixed(0)}</p>
                        ),
                    };
                } else {
                    return {
                        children: (
                            <div className="category-row-container h-[25px]">{displayValue}</div>
                        ),
                    };
                }
            },
        },
        {
            title: "Dealer Comm.",
            dataIndex: "commision_percentage",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div className="text-[#1B252F] text-[13px] mb-3">
                            {record.commision_percentage} % (${record.commision_amount})
                        </div>
                    </Fragment>
                );
            },
        },
        {
            title: "Disbursement Date",
            dataIndex: "expiry",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <div className="text-[#1B252F] text-[13px] mb-3">{record.disb_date}</div>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            width: 90,
            render: (text, record) => {
                if (!record.isCategoryRow) {
                    return (
                        <div>
                            {pagePermission?.view_permission == 1 && (
                                <span
                                    onClick={() => {
                                        clearLocalStorageExceptOne("agentModuleToken");
                                        localStorage.setItem("applicationId", record.id);
                                        localStorage.removeItem("tabValue");
                                        navigate("/case-detail", {
                                            state: { Id: record.id, pagePermission: pagePermission },
                                        });
                                    }}
                                    className="mb-2 text-[#203B50] text-[14px] flex flex-wrap cursor-pointer border-none shadow-none"
                                >
                                    <span><EyeOutlined className="mb-3" />&nbsp;View</span>
                                </span>
                            )}
                        </div>
                    );
                }
            },
        },
    ];

    const expiredColumns = [
        {
            title: "Application ID",
            dataIndex: "id",
            fixed: window.innerWidth < 767 ? " " : "left",
            width: 100,
            sorter: false,
            render: (text, record) => {
                if (text) {
                    return {
                        children: (
                            <>
                                <div>OAP-{record.unique_id.toString().padStart(6, "0")}</div>
                                {record?.dealer_name && (
                                    <div className="font-[700]">{record?.dealer_name}</div>
                                )}
                            </>
                        ),
                    };
                }
            },
        },
        {
            title: "Loan Type",
            dataIndex: "loan_type",
            sorter: false,
            width: 100,
            render: (_, { loan_type }) => (
                <>
                    {loan_type != undefined &&
                        loan_type.map((tag) => {
                            return (
                                <Tag
                                    className="mb-2 text-center"
                                    style={{ width: "80px" }}
                                    color={"#DDEAFF"}
                                    key={tag}
                                >
                                    <span className="font-[600]" style={{ color: "#0560FB" }}>
                                        {tag.toUpperCase()}
                                    </span>
                                </Tag>
                            );
                        })}
                </>
            ),
        },
        {
            title: "Veh/Chassis No",
            dataIndex: "veh_chassis_no",
            sorter: false,
            width: 130,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            <span
                                onClick={() => {
                                    localStorage.setItem("applicationId", record.id);
                                    navigate("/case-detail", {
                                        state: { Id: record.id, pagePermission: pagePermission },
                                    });
                                }}
                                className="text-[#0560FB] text-[13px] font-[700] cursor-pointer"
                            >
                                {record.vehicle_reg_no}
                            </span>
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Make/Model",
            dataIndex: "veh_make_model",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Loan Amt",
            dataIndex: "loan_amt",
            sorter: false,
            width: 90,
            render: (text, record) => {
                const displayValue =
                    record.counter_loan_amt !== undefined &&
                        record.counter_loan_amt !== null &&
                        record.counter_loan_amt !== ""
                        ? record.counter_loan_amt
                        : text;

                if (!record.isCategoryRow) {
                    return {
                        children: (
                            <p>${parseInt(displayValue).toFixed(0)}</p>
                        ),
                    };
                } else {
                    return {
                        children: (
                            <div className="category-row-container h-[25px]">{displayValue}</div>
                        ),
                    };
                }
            },
        },
        {
            title: "Customer Selected",
            dataIndex: "customer_selected",
            sorter: false,
            width: 140,
            render: (text, record) => {
                if (!record.isCategoryRow) {
                    return (
                        <div className="flex justify-center items-center">
                            <img
                                src={
                                    record.customer_selected > 0
                                        ? "/images/selected.png"
                                        : "/images/rejected.png"
                                }
                                alt="Centered Image"
                                className="max-w-full max-h-full"
                            />
                        </div>
                    );
                }
            },
        },
        {
            title: "Application Status",
            dataIndex: "approved",
            sorter: false,
            width: 170,
            render: (text, record) => {
                if (!record.isCategoryRow) {
                    return (
                        <div className="text-start">
                            <Popover content={"Approved"}>
                                <Badge
                                    className="mr-2 badge"
                                    title=" "
                                    showZero={true}
                                    color="#00AE11"
                                    style={{ width: "30px" }}
                                    count={record.approved}
                                />
                            </Popover>
                            <Popover content={"Counter Offer"}>
                                <Badge
                                    className="mr-2"
                                    title=" "
                                    showZero
                                    color="#f48037"
                                    style={{ width: "30px" }}
                                    count={record.counter}
                                />
                            </Popover>
                            <Popover content={"Rejected"}>
                                <Badge
                                    className="mr-2"
                                    title=" "
                                    showZero
                                    color="#D30000"
                                    style={{ width: "30px" }}
                                    count={record.rejected}
                                />
                            </Popover>
                            <Popover content={"Pending"}>
                                <Badge
                                    className="mr-2"
                                    title=" "
                                    showZero
                                    color="#D4D4D4"
                                    style={{ width: "30px" }}
                                    count={record.pending}
                                />
                            </Popover>
                        </div>
                    );
                }
            },
        },
        {
            title: "Created at",
            dataIndex: "created_at",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div className="text-[#1B252F] text-[13px]">
                            {record.created_at}

                        </div>
                    </Fragment>
                );
            },
        },
        {
            title: "Case Exp",
            dataIndex: "expiry",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <div className="text-[#1B252F] text-[13px]">
                        {record.expiryDateTime}
                    </div>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            width: 90,
            render: (text, record) => {
                if (!record.isCategoryRow) {
                    return (
                        <div>
                            {pagePermission?.view_permission == 1 && (
                                <span
                                    onClick={() => {
                                        clearLocalStorageExceptOne("agentModuleToken");
                                        localStorage.setItem("applicationId", record.id);
                                        localStorage.removeItem("tabValue");
                                        navigate("/case-detail", {
                                            state: { Id: record.id, pagePermission: pagePermission },
                                        });
                                    }}
                                    className="mb-2 text-[#203B50] text-[14px] flex flex-wrap cursor-pointer border-none shadow-none"
                                >
                                    <EyeOutlined className="mt-1" />
                                    <span>&nbsp;View</span>
                                </span>
                            )}
                            {pagePermission?.delete_permission == 1 && (
                                <span
                                    className="mb-2 text-[#F80707] text-[14px] flex flex-wrap cursor-pointer border-none shadow-none"
                                    onClick={() => {
                                        if (Number(record.approved) == 0) {
                                            setDelModal(true);
                                            setDelid(record.id);
                                        } else {
                                            toast.warning(`You have approved ${record.approved} loan products. Please reject it and try again.`)
                                        }
                                    }}
                                >
                                    <DeleteOutlined className="mt-1" />
                                    <span>&nbsp;Delete</span>
                                </span>
                            )}
                        </div>
                    );
                }
            },
        },
    ];

    const disbursementCompletedColumns = [
        {
            title: "Application ID",
            dataIndex: "id",
            fixed: window.innerWidth < 767 ? " " : "left",
            width: 100,
            sorter: false,
            render: (text, record) => {
                if (text) {
                    return {
                        children: (
                            <>
                                <div>OAP-{record.unique_id.toString().padStart(6, "0")}</div>
                                {record?.dealer_name && (
                                    <div className="font-[700] ">{record?.dealer_name}</div>
                                )}
                                <div>{record?.product_name}</div>
                            </>
                        ),
                    };
                }
            },
        },
        {
            title: "Loan Type",
            dataIndex: "loan_type",
            sorter: false,
            width: 100,
            render: (_, { loan_type }) => (
                <>
                    {loan_type != undefined &&
                        loan_type.map((tag) => {
                            return (
                                <Tag
                                    className="mb-2 text-center"
                                    style={{ width: "80px" }}
                                    color={"#DDEAFF"}
                                    key={tag}
                                >
                                    <span className="font-[600]" style={{ color: "#0560FB" }}>
                                        {tag.toUpperCase()}
                                    </span>
                                </Tag>
                            );
                        })}
                </>
            ),
        },
        {
            title: "Veh/Chassis No",
            dataIndex: "veh_chassis_no",
            sorter: false,
            width: 130,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            <span
                                onClick={() => {
                                    localStorage.setItem("applicationId", record.id);
                                    navigate("/case-detail", {
                                        state: { Id: record.id, pagePermission: pagePermission },
                                    });
                                }}
                                className="text-[#0560FB] text-[13px] font-[700] cursor-pointer"
                            >
                                {record.vehicle_reg_no}
                            </span>
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Make/Model",
            dataIndex: "veh_make_model",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Loan Amt",
            dataIndex: "loan_amt",
            sorter: false,
            width: 90,
            render: (text, record) => {
                const displayValue =
                    record.counter_loan_amt !== undefined &&
                        record.counter_loan_amt !== null &&
                        record.counter_loan_amt !== ""
                        ? record.counter_loan_amt
                        : text;

                if (!record.isCategoryRow) {
                    return {
                        children: (
                            <p>${parseInt(displayValue).toFixed(0)}</p>
                        ),
                    };
                } else {
                    return {
                        children: (
                            <div className="category-row-container h-[25px]">{displayValue}</div>
                        ),
                    };
                }
            },
        },
        {
            title: "Dealer Comm.",
            dataIndex: "commision_percentage",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div className="text-[#1B252F] text-[13px] mb-3">
                            {record.commision_percentage} % (${record.commision_amount})
                        </div>
                    </Fragment>
                );
            },
        },
        {
            title: "Status",
            dataIndex: "expiry",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div
                            className={`text-[13px] font-medium mb-[16px] ${record.invoice_status_code === 0
                                ? 'text-orange-500'
                                : record.invoice_status_code === 1
                                    ? 'text-blue-500'
                                    : record.invoice_status_code === 2
                                        ? 'text-yellow-500'
                                        : record.invoice_status_code === 3
                                            ? 'text-green-500'
                                            : 'text-gray-500'
                                }`}
                        >
                            {record.invoice_status_code === 0
                                ? 'Pending'
                                : record.invoice_status_code === 1
                                    ? 'Invoice Received'
                                    : record.invoice_status_code === 2
                                        ? 'Submitted'
                                        : record.invoice_status_code === 3
                                            ? 'Paid'
                                            : 'Unknown'}
                        </div>
                    </Fragment>
                );
            },
        },
        {
            title: "Invoice Payment Date",
            dataIndex: "expiry",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <div className="text-[#1B252F] text-[13px] mb-3">{record.invoice_start_date}</div>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            width: 90,
            render: (text, record) => {
                if (!record.isCategoryRow) {
                    return (
                        <div className="mb-4 text-[#203B50] text-[14px] flex items-center gap-4">
                            <Tooltip title="Invoice Details" placement="top">
                                <div
                                    className={`flex items-center justify-center cursor-pointer ${record.invoice_status_code === 0 ? 'opacity-50' : ''
                                        }`}
                                    onClick={() => {
                                        if (record.invoice_status_code !== 0) {
                                            navigate('/view-invoice', { state: { record } });
                                        }
                                    }}
                                >
                                    <img src={invoiceImage} alt="Invoice" className="w-[28px] h-auto" />
                                </div>
                            </Tooltip>

                            <Tooltip title="Payment Details" placement="top">
                                <div
                                    className={`flex items-center justify-center cursor-pointer ${record.invoice_status_code < 2 ? 'opacity-50' : ''
                                        }`}
                                    onClick={(e) => {
                                        if (record.invoice_status_code >= 2) {
                                            e.stopPropagation();
                                            setSelectedRecord(record);
                                            setPopupOpen(true);
                                        }
                                    }}
                                >
                                    <img src={paymentImage} alt="Invoice" className="w-[28px] h-auto" />
                                </div>
                            </Tooltip>
                        </div>

                    );
                }
            },
        },
    ];

    useEffect(() => {
        let listData = data;
        let updateListData = [];
        if (listData != undefined && listData.length > 0) {
            listData?.map((list, idx) => {
                let loanTypes = list?.loanTypeLabels;
                let detail = {};
                detail["key"] = idx + 1;
                detail["id"] = list.id;
                detail["user_type"] = list?.user_type;
                detail["loan_type"] = loanTypes;
                detail["created_at"] = moment(list["created_at"]).format(
                    "DD-MM-YYYY  HH:mm"
                );
                detail["veh_chassis_no"] = list.vehicle_details?.vehicle_chassis_no;
                detail["vehicle_reg_no"] = list.vehicle_details?.vehicle_reg_no;
                detail["veh_make_model"] = list.vehicle_details?.make_model;
                detail["unique_id"] = list.uniqueId;
                detail["dealer_name"] = list.ownerinfo?.name;
                detail["loan_amt"] = list.loanamount;
                detail["counter_loan_amt"] = list?.counter_offer_update?.loanamount;
                detail["customer_selected"] = list.customer_selected;
                detail["approved"] = list.approved;
                detail["pending"] = list.pending;
                detail["rejected"] = list.rejected;
                detail["counter"] = list.counter_offered;
                detail["expiryDateTime"] = moment(list["expired_at"]).format(
                    "DD-MM-YYYY  HH:mm"
                );
                detail["type"] = list.typeinfo?.name;
                detail["disb_date"] = list?.disbursementinfo?.disbursement_date !== null
                    ? moment(list?.disbursementinfo?.disbursement_date).format(
                        "DD-MM-YYYY"
                    )
                    : "";
                detail["commision_amount"] = list?.disbursementinfo
                    ? list?.disbursementinfo?.commision_amount
                    : "0";
                detail["commision_percentage"] = list?.disbursementinfo
                    ? list?.disbursementinfo?.commision_percentage
                    : "0";
                detail["product_name"] = list?.disbursementinfo?.applicationproductinfo
                    ?.productinfo
                    ? list?.disbursementinfo?.applicationproductinfo?.productinfo?.name
                    : "";
                detail["invoice_status_code"] = list?.invoice_status_code;
                detail["invoice_auto_confirm"] = list?.expiry_time;
                detail["invoice_start_date"] = list?.invoice_start_date;
                detail["invoice_remarks"] = list?.invoice_remarks;
                detail["invoice_disbursement_doc"] = list?.invoice_disbursement_doc;
                detail["agent_mail_address"] = list?.ownerinfo?.email;
                updateListData.push(detail);
            });
            setListDetails(updateListData);
        } else {
            setListDetails([]);
        }
    }, [data]);

    useEffect(() => {
        if (type == "expired") {
            setColumnType(expiredColumns);
        } else if (type == "pending") {
            setColumnType(columns);
        } else if (type == "disbursement") {
            setColumnType(disbursementcolumns);
        } else {
            setColumnType(disbursementCompletedColumns);
        }
    }, [type, seconds]);

    useEffect(() => {
        if (seconds > 0) {
            const interval = setInterval(() => {
                setSeconds(prev => prev - 1);
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [seconds]);

    return (
        <div className="table-container">
            {/* View Report */}
            <Modal
                open={popupOpen}
                onCancel={() => {
                    setPopupOpen(false);
                }}
                centered
                footer={null}
            >
                <div className="reject-popup-block">
                    <h2 className="text-center ">Invoice Report</h2>
                    <div className="flex flex-col">
                        <div className="mb-6 text-sm font-medium text-gray-700">
                            <strong className="ml-8">Invoice Start Date:</strong><span className="ml-7">{selectedRecord?.invoice_start_date}</span>
                        </div>
                        <div className="mb-1 text-sm font-medium text-gray-700">
                            <strong className="ml-8">Invoice Remarks:</strong><span className="ml-10">{selectedRecord?.invoice_remarks}</span>
                        </div>
                        <div className="mb-6 text-sm font-medium text-gray-700">
                            <div className="preview-list-block">
                                <div className="download-block">
                                    <strong>Invoice Documents:</strong>
                                </div>
                                <div className="preview-list-group mb--8" >
                                    {selectedRecord?.invoice_disbursement_doc?.length > 0 && (
                                        <UploadedDocuments
                                            documents={AddLabelToFile(
                                                selectedRecord?.invoice_disbursement_doc,
                                            )}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className=" mb-2 mt-0 flex justify-end">
                        <Button
                            type="primary"
                            onClick={() => setPopupOpen(false)}
                        >
                            Close
                        </Button>
                    </div> */}
                </div>
            </Modal>

            <Modal
                title="Delete Application"
                centered
                open={delModal}
                onOk={async () => {
                    const tokenId = localStorage.getItem("dealerModuleToken");
                    const resp = await axios.delete(`/loan/application/delete/${delId}`);
                    if (resp) {
                        props.fetchLoanCase();
                        toast.success("Deleted Successfully!!!", { autoClose: 2500 });
                        setDelModal(false);
                    }
                }}
                onCancel={() => setDelModal(false)}
                wrapClassName="delApplModal"
                okText={
                    <>
                        <DeleteOutlined />
                        &nbsp;Delete
                    </>
                }
            >
                <p>Are you sure want to delete?</p>
            </Modal>
            <Table
                showSorterTooltip={false}
                dataSource={listDetails}
                columns={columnType}
                pagination={true}
                scroll={{ x: type != "expired" ? 1300 : 1300 }}
                rowKey={(record, index) => index}
                locale={customLocale}
                className="custom-table"
            />
        </div>
    );
};

export default LoanTabDatas;
